var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInboxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.796265,
    width: 18.7963,
    height: 18.7963,
    rx: 4,
    fill: "#00B103",
    fillOpacity: 0.03
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.57748 6.62793L8.76917 8.43636C9.94583 9.10306 10.443 9.10306 11.6196 8.43636L14.8113 6.62793",
    stroke: "#006838",
    strokeWidth: 0.692538,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.58477 10.0793C5.61495 11.4947 5.63004 12.2023 6.15227 12.7265C6.6745 13.2507 7.40132 13.269 8.85496 13.3055C9.75086 13.328 10.638 13.328 11.5339 13.3055C12.9875 13.269 13.7143 13.2507 14.2366 12.7265C14.7588 12.2023 14.7739 11.4947 14.804 10.0793C14.8138 9.6242 14.8138 9.17183 14.804 8.71674C14.7739 7.30141 14.7588 6.59374 14.2366 6.06952C13.7143 5.5453 12.9875 5.52704 11.5339 5.49052C10.638 5.46801 9.75086 5.46801 8.85495 5.49051C7.40132 5.52703 6.6745 5.54529 6.15227 6.06952C5.63003 6.59373 5.61495 7.3014 5.58476 8.71674C5.57506 9.17183 5.57506 9.6242 5.58477 10.0793Z",
    stroke: "#006838",
    strokeWidth: 0.692538,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInboxIcon);
export default __webpack_public_path__ + "static/media/InboxIcon.f4216c0916b438cbe3646f7f20d7bd48.svg";
export { ForwardRef as ReactComponent };